import React from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Close as CloseIcon, DeleteOutline as DeleteOutlineIcon } from "@mui/icons-material";

import { Contact } from "../../../../../../../../models/contact";

import Button, { Color } from "../../../../../../../../components/Form/Button";

import useStyles from "./styles";

interface Props {
  contact?: Contact;
  isLoadingDelete: boolean;
  handleClose: () => void;
  handleDeleteContact?: (contact: Contact) => void;
}

const ConfirmDeleteModal = (props: Props) => {
  const { handleClose, handleDeleteContact, contact, isLoadingDelete } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <Grid
      container
      direction="row"
      data-cy="confirmDeleteModal"
      className={classes.confirmModalContainer}
    >
      <Grid container direction="row" className={classes.confirmModalContent}>
        <Grid item xs={12} className={classes.header}>
          <div className={classes.deleteWarningContainer}>
            <div className={classes.deleteIcon}>
              <DeleteOutlineIcon fontSize="medium" htmlColor="#F32D2D" onClick={handleClose} />
            </div>
            <span className={classes.modalTitle}>Delete business contact</span>
          </div>

          <CloseIcon
            fontSize="medium"
            htmlColor="#232325"
            onClick={handleClose}
            className={classes.pointer}
          />
        </Grid>

        <Grid item xs={12} className={classes.confirm}>
          <span>
            You are about to delete the contact{" "}
            {contact ? `"${contact.firstName} ${contact.lastName}"` : ""}. Are you sure you want to
            continue?
          </span>
        </Grid>

        <Grid item xs={12} className={classes.warning}>
          <span>This action is permanent and cannot be undone!</span>
        </Grid>
      </Grid>

      <Grid item xs={12} className={classes.contactsButtonsContainer}>
        <Button
          className={`mr-2 ${classes.buttonClose}`}
          customColor={Color.CANCEL}
          data-cy="confirmCancelButton"
          onClick={() => handleClose()}
        >
          <strong>{translate("cancel")}</strong>
        </Button>

        <Button
          className={classes.buttonDelete}
          customColor={Color.ERROR}
          loading={isLoadingDelete}
          disabled={isLoadingDelete}
          data-cy="confirmDeleteButton"
          onClick={handleDeleteContact && contact && (() => handleDeleteContact(contact))}
        >
          <strong>{translate("delete")}</strong>
        </Button>
      </Grid>
    </Grid>
  );
};

export default ConfirmDeleteModal;
